import { IconContentFormatBold } from '@doltech/icons/IconContentFormatBold';
import { IconContentFormatColor } from '@doltech/icons/IconContentFormatColor';
import { IconContentFormatItalic } from '@doltech/icons/IconContentFormatItalic';
import { IconContentFormatStrike } from '@doltech/icons/IconContentFormatStrike';
import { IconContentFormatUnderline } from '@doltech/icons/IconContentFormatUnderline';
import { IconContentHighlight } from '@doltech/icons/IconContentHighlight';
import { IconContentLayoutList } from '@doltech/icons/IconContentLayoutList';
import { IconContentLayoutNum } from '@doltech/icons/IconContentLayoutNum';
import * as React from 'react';
import styled from 'styled-components';
import { Grid } from 'styled-css-grid';

import { ToolbarMark } from '../../../../slatePlugins/components/ToolbarMark/ToolbarMark';
import { MARK_BOLD } from '../../../../slatePlugins/marks/bold/defaults';
import { MARK_ITALIC } from '../../../../slatePlugins/marks/italic/defaults';
import { MARK_STRIKETHROUGH } from '../../../../slatePlugins/marks/strikethrough/defaults';
import { DEFAULTS_OPTIONS } from '../../../BlogEditor/editorDefaultOptions';
import {
  DEFAULT_HIGHLIGHT_COLORS_LIST,
  ELEMENT_HIGHLIGHT,
} from '../../elements/highlight/defaults';
import { ToolbarHighlightElement } from '../../elements/highlight/toolbar/ToolbarHighlightElement';
import { ELEMENT_NUMBERING } from '../../elements/numbering/defaults';
import { ELEMENT_ROUNDED } from '../../elements/rounded/defaults';
import { ToolbarRoundedContextAction } from '../../elements/rounded/toolbar/ToolbarRoundedContextAction';
import { DEFAULT_TEXT_COLOR_LIST, MARK_TEXT_COLOR } from '../../marks/text-color/defaults';
import { ToolbarTextColorMark } from '../../marks/text-color/toolbar/ToolbarTextColorMark';
import { MARK_UNDERLINE_COLOR } from '../../marks/underline-color/defaults';
import { ToolbarUnderlineColorMark } from '../../marks/underline-color/toolbar/ToolbarUnderlineColorMark';
import { disable } from '../disable-item/withDisableToolbarItem';
import { SideToolbarItemStyle } from './SideToolbarItemStyle';
import { SideToolbarOnFocus } from './SideToolbarOnFocus';

const StyledToolbarMark = styled(ToolbarMark)`
  ${SideToolbarItemStyle}
`;

export const QUESTION_SIDE_TOOLBAR_ITEMS = {
  toolbar: (options = DEFAULTS_OPTIONS) => {
    return (
      <>
        <StyledToolbarMark
          styles={SideToolbarItemStyle}
          reversed
          type={MARK_BOLD}
          icon={<IconContentFormatBold />}
        />

        <StyledToolbarMark
          styles={SideToolbarItemStyle}
          reversed
          type={MARK_ITALIC}
          icon={<IconContentFormatItalic />}
        />

        <StyledToolbarMark
          styles={SideToolbarItemStyle}
          reversed
          type={MARK_STRIKETHROUGH}
          icon={<IconContentFormatStrike />}
        />

        <disable.ToolbarList
          {...options.ul}
          disable={{
            onActiveElementType: [
              ELEMENT_ROUNDED,
              ELEMENT_HIGHLIGHT,
              ELEMENT_NUMBERING,
              options.h1.type,
            ],
          }}
          styles={SideToolbarItemStyle}
          typeList={options.ul.type}
          icon={<IconContentLayoutList />}
        />

        <ToolbarUnderlineColorMark
          type={MARK_UNDERLINE_COLOR}
          styles={SideToolbarItemStyle}
          colors={DEFAULT_TEXT_COLOR_LIST}
          icon={<IconContentFormatUnderline />}
        />

        <disable.ToolbarList
          {...options.ol}
          disable={{
            onActiveElementType: [
              ELEMENT_ROUNDED,
              ELEMENT_HIGHLIGHT,
              ELEMENT_NUMBERING,
              options.h1.type,
            ],
          }}
          styles={SideToolbarItemStyle}
          typeList={options.ol.type}
          icon={<IconContentLayoutNum />}
        />

        <ToolbarTextColorMark
          type={MARK_TEXT_COLOR}
          styles={SideToolbarItemStyle}
          colors={DEFAULT_TEXT_COLOR_LIST}
          icon={<IconContentFormatColor />}
        />

        <ToolbarHighlightElement
          disable={{
            onActiveElementType: [ELEMENT_ROUNDED, ELEMENT_NUMBERING, options.h1.type],
          }}
          styles={SideToolbarItemStyle}
          type={ELEMENT_HIGHLIGHT}
          icon={<IconContentHighlight />}
          colors={DEFAULT_HIGHLIGHT_COLORS_LIST}
        />
      </>
    );
  },
};

export const QuestionSideToolbar = ({ containerRef }) => {
  return (
    <>
      <SideToolbarOnFocus
        id="question-side-toolbar"
        spacing={24}
        containerRef={containerRef}
        placement="left"
      >
        <Grid columns={2} columnGap="12px" rowGap="6px" justifyContent="center">
          {QUESTION_SIDE_TOOLBAR_ITEMS.toolbar()}
        </Grid>
      </SideToolbarOnFocus>
      <ToolbarRoundedContextAction />
    </>
  );
};
